export function truncateAddress(address: string, head = 4, tail = 4): string {
  if (!address) return "";
  if (address.length <= head + tail + 2) return address;
  return `${address.slice(0, head)}…${address.slice(-tail)}`;
}

const amountFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const preciseFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export function formatAmount(value: number | string, precise = false): string {
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return (precise ? preciseFormatter : amountFormatter).format(n);
}

export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  return `$${amountFormatter.format(value)}`;
}

/** Ripple epoch (2000-01-01) seconds to a local time string. */
export function formatLedgerTime(rippleSeconds: number | null): string {
  if (rippleSeconds === null) return "pending";
  const ms = (rippleSeconds + 946_684_800) * 1000;
  return new Date(ms).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Short visual fingerprint of an address, so users can compare at a glance. */
export function addressFingerprint(address: string): string {
  if (!address) return "";
  let hash = 0;
  for (let i = 0; i < address.length; i++) {
    hash = (hash * 31 + address.charCodeAt(i)) % 0xffffff;
  }
  return hash.toString(16).toUpperCase().padStart(6, "0");
}

export function initialsFor(code: string): string {
  return code.replace(/[^A-Za-z0-9]/g, "").slice(0, 2).toUpperCase() || "??";
}
